<div class="overlay">
  <div class="modal">
    <div class="back-link"><a id="bt_modal_close" (click)="modal_close($event)">戻る</a></div>
    <div class="modal_contents">
      <ng-content></ng-content>
      <!-- <app-guest-select (event)="onReceiveEventFromChild($event)"></app-guest-select> -->
    </div>
  </div>
</div>
